module.exports = __webpack_public_path__ + "img/distanceWedge3.2bfea0d9.png";